import { useMemo } from "react";
import { useTheme } from "lib/theme";
import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";
import { ProjectAppearance } from "server/schemas/projects";
import { defaultCustomizableThemeColors } from "lib/theme/themes/app-theme";

export const useProjectTheme = ({
  projectAppearance,
}: {
  projectAppearance?: ProjectAppearance;
} = {}) => {
  const theme = useTheme();

  const userTheme = useMemo(() => {
    const currentTheme = cloneDeep(theme);
    const userAppearanceSetting = {
      app: {
        colors: {
          ...defaultCustomizableThemeColors,
          ...projectAppearance,
          themeBackground:
            projectAppearance?.pageBackground ??
            theme.app.colors.themeBackground,
          pageBackground:
            projectAppearance?.pageBackground ??
            theme.app.colors.themeBackground,
        },
      },
    };
    return merge(currentTheme, userAppearanceSetting);
  }, [projectAppearance, theme]);

  return userTheme;
};
